export const LIBRARY_TAB = {
  OBJECT: "Object",
  MY_ASSET: "My Asset",
};

export const LIBRARY_OPTION = {
  SEARCH: "search",
  FAVORITE: "favorite",
  NONE: "none",
};

export const ASSET_TYPE = {
  MODEL: "MODEL",
  IMAGE: "IMAGE",
  VIDEO: "VIDEO",
  SOUND: "SOUND",
  MESH: "MESH",
  GUI: "GUI",
  LIGHT: "LIGHT",
  EFFECT: "EFFECT",
  CAMERA: "CAMERA",
  SPAWN: "SPAWN",
  STARTING_POINT: "starting_point",
  PORTAL: "portal",
  AD_MODEL: "ADASSET",
  NOT_SUPPORTED: "NOT_SUPPORTED",
};

export const RECOMMEND = "recommend";

export const ASSET_GENRE = {
  ALL: "ALL",
  VEHICLE: "VEHICLE",
  BUILDING: "BUILDING",
  STRUCTURE: "STRUCTURE",
  NATURE: "NATURE",
  FURNITURE: "FURNITURE",
  DECORATION: "DECORATION",
  MACHINE: "MACHINE",
  FOODS: "FOODS",
  GROUND: "GROUND",
};

export const MIME_TYPE = {
  GLTF: "gltf",
};

export const ASSET_GENRE_ALL = [
  ASSET_GENRE.VEHICLE,
  ASSET_GENRE.BUILDING,
  ASSET_GENRE.STRUCTURE,
  ASSET_GENRE.NATURE,
  ASSET_GENRE.FURNITURE,
  ASSET_GENRE.DECORATION,
  ASSET_GENRE.MACHINE,
  ASSET_GENRE.FOODS,
  ASSET_GENRE.GROUND,
];

export const MY_ASSET_CATEGORY = {
  ASSET: "asset",
  NFT: "nft",
};

export const libraryTabList = [
  {
    id: 0,
    title: LIBRARY_TAB.OBJECT,
  },
  {
    id: 1,
    title: LIBRARY_TAB.MY_ASSET,
  },
];

// temporal code for staging env test
export const stagingLibraryTabList = [
  {
    id: 0,
    title: LIBRARY_TAB.OBJECT,
  },
];

export const myAssetList = [
  {
    id: "sldkfj3234234",
    glb: "asset/demo_asset/glb_set_1/bank.glb",
    thumbnail: "https://redbrick-asset-store.s3.ap-northeast-2.amazonaws.com/thumbnail/asset_sample.png",
    keywords: ["sdf", "tag", "city"],
    name: "bank",
  },
  {
    id: "sldkjf2oi3rn4030943jdmc",
    glb: "asset/demo_asset/glb_set_1/barrier.glb",
    thumbnail: "https://redbrick-asset-store.s3.ap-northeast-2.amazonaws.com/thumbnail/asset_sample.png",
    name: "barrier",
  },
  {
    id: "sldkjf2oi3rn4030943jdmsdc",
    glb: "https://d2f4dt8igm02oj.cloudfront.net/asset/0bad6be3-23bd-4751-908f-d35abc3934d5",
    thumbnail: "https://redbrick-asset-store.s3.ap-northeast-2.amazonaws.com/thumbnail/asset_sample.png",
    name: "barrier",
  },
];

export const SAMPLE_THUMBNAIL_MODEL = "https://redbrick-asset-store.s3.ap-northeast-2.amazonaws.com/thumbnail/asset_sample.png";

export const myAssetTypeList = [
  {
    id: 0,
    title: "ID_MYASSET_TYPE_MODEL",
    type: ASSET_TYPE.MODEL,
  },
  {
    id: 1,
    title: "ID_MYASSET_TYPE_IMAGE",
    type: ASSET_TYPE.IMAGE,
  },
  {
    id: 2,
    title: "ID_ASSET_TYPE_VIDEO",
    type: ASSET_TYPE.VIDEO,
  },
  {
    id: 3,
    title: "ID_ASSET_TYPE_SOUND",
    type: ASSET_TYPE.SOUND,
  },
];

export const genreList = [
  {
    id: 0,
    title: "ID_ASSET_GENRE_ALL",
    genre: ASSET_GENRE.ALL,
  },
  {
    id: 1,
    title: "ID_ASSET_GENRE_BUILDING",
    genre: ASSET_GENRE.BUILDING,
  },
  {
    id: 2,
    title: "ID_ASSET_GENRE_DECORATION",
    genre: ASSET_GENRE.DECORATION,
  },
  {
    id: 3,
    title: "ID_ASSET_GENRE_FOODS",
    genre: ASSET_GENRE.FOODS,
  },
  {
    id: 4,
    title: "ID_ASSET_GENRE_FURNITURE",
    genre: ASSET_GENRE.FURNITURE,
  },
  {
    id: 5,
    title: "ID_ASSET_GENRE_MACHINE",
    genre: ASSET_GENRE.MACHINE,
  },
  {
    id: 6,
    title: "ID_ASSET_GENRE_NATURE",
    genre: ASSET_GENRE.NATURE,
  },
  {
    id: 7,
    title: "ID_ASSET_GENRE_STRUCTURE",
    genre: ASSET_GENRE.STRUCTURE,
  },
  {
    id: 8,
    title: "ID_ASSET_GENRE_VEHICLE",
    genre: ASSET_GENRE.VEHICLE,
  },
  {
    id: 9,
    title: "ID_ASSET_GENRE_GROUND",
    genre: ASSET_GENRE.GROUND,
  },
];

export const genreDropdownList = genreList.filter(item => {
  return item.genre !== ASSET_GENRE.ALL;
});

export const myAssetCategory = [
  {
    id: 0,
    title: "ID_MYASSET_CATEGORY_ASSET",
    category: MY_ASSET_CATEGORY.ASSET,
  },
  {
    id: 1,
    title: "ID_MYASSET_CATEGORY_NFT",
    category: MY_ASSET_CATEGORY.NFT,
  },
];

export const assetTypeList = [
  {
    id: 0,
    title: "ID_RECOMMEND",
    type: RECOMMEND,
  },
  {
    id: 1,
    title: "ID_ASSET_TYPE_MODEL",
    type: ASSET_TYPE.MODEL,
  },
  {
    id: 2,
    title: "ID_ASSET_TYPE_MESH",
    type: ASSET_TYPE.MESH,
  },
  {
    id: 3,
    title: "ID_ASSET_TYPE_GUI",
    type: ASSET_TYPE.GUI,
  },
  {
    id: 4,
    title: "ID_ASSET_TYPE_VIDEO",
    type: ASSET_TYPE.VIDEO,
  },
  {
    id: 5,
    title: "ID_ASSET_TYPE_SOUND",
    type: ASSET_TYPE.SOUND,
  },
  {
    id: 6,
    title: "ID_ASSET_TYPE_LIGHT",
    type: ASSET_TYPE.LIGHT,
  },
  {
    id: 7,
    title: "ID_ASSET_TYPE_EFFECT",
    type: ASSET_TYPE.EFFECT,
  },
  {
    id: 8,
    title: "ID_ASSET_TYPE_SPAWN",
    type: ASSET_TYPE.SPAWN,
  },
  {
    id: 9,
    title: "ID_ASSET_TYPE_AD",
    type: ASSET_TYPE.AD_MODEL,
  },
];

export const recommendSearchList = [
  "halloween",
  "dessert",
  "city",
  "forest",
  "dungeon",
  "medieval",
  "desert",
  "space",
  "interior",
  "tree",
  "grass",
];

export const S3_FOLDER = {
  THUMBNAIL: "thumbnail",
  ASSET: "asset",
};

export const ASSET_REQUEST_LIMIT = 40;
